import React, { useEffect, useState } from "react";

import { ISorter } from "../../models/interfaces/ISorter";
import { useFetchNoticesAparaitreQuery } from "../../redux/slice/api/FO/noticeApi";


import CpntDataTable from "../../components/dataTable/CpntDataTable";
import { ITitle } from "../../models/interfaces/ITitle";
import { ILocation } from "../../models/interfaces/ILocation";
import { INotice, INoticeDTO } from "../../models/interfaces/INotice";
import { useKeycloak } from "@react-keycloak/web";
import HtmlRenderModalImage from "./components/HtmlRender/HtmlRenderImageICon";
import CpntPagination from "../../components/CpntPagination";
import HtmlRenderDisponibiliteEtendu from "./components/HtmlRender/HtmlRenderDisponibiliteEtendu";
import { IToggleView } from "../../models/interfaces/IToggleView";
import { ModificationBloque, SourcesModifiable } from "../../config/helpers";
import { toast } from "react-toastify";
import SpinnerEditeurPro from "./components/SpinnerEditeurPro";
import { filterToQueryNoticeAapraitre, getDefaultFilterNoticeAapraitre, IFilterNoticeAapraitre } from "../../models/interfaces/IFilterNoticeAapraitre";
import CpntFacette from "../../components/CpntFacette";
import { useNavigate } from "react-router-dom";


const PageNoticesAparaitre: React.FC = () => {
  const [listfilter, setListFilter] = useState<IFilterNoticeAapraitre>();
  const [searchParamsNoticeAparaitre, setSearchParamsNoticeAparaitre] = useState<IFilterNoticeAapraitre|undefined>(undefined);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  //const [facettes, setFacettes] = useState<IFacetteFiltre[]>([]); // |null
  const [isDescending, setIsDescending] = useState<boolean>();
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  //const [initiateDownload, setInitiateDownload] = useState(false)
  //const [csvDataToDownload, setCsvDataToDownload] = useState(null)
  //const [editeur, setediteur] = useState(""); // État local pour stocker la valeur de l'entrée
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  //const [selectedIds, setSelectedIds] = useState<string [] |undefined>();


  useEffect(() => {
    const _filterNoticesAapraitre: IFilterNoticeAapraitre = filterToQueryNoticeAapraitre({
      Offset:0,
      Limit: 10 // to be fast
    });
    setSearchParamsNoticeAparaitre(_filterNoticesAapraitre);
  }, [])
   

  useEffect(() => {
    const storedFilter = localStorage.getItem("IFilterNoticesAapraitre");
    const storedSorter = localStorage.getItem("ISortStore");

    if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
      setListFilter(JSON.parse(storedFilter));
    } else {
      setListFilter(getDefaultFilterNoticeAapraitre());
    }

    if (storedSorter !== null && storedSorter !== undefined) {
      const currSorter:ISorter = JSON.parse(storedSorter);
      currSorter?.orderedcolumnid && setSortField(currSorter?.orderedcolumnid);
      currSorter?.orderedasc && setIsDescending(!currSorter?.orderedasc);
    }
   
  }, []);

  useEffect(() => {
    if (listfilter && listfilter !== getDefaultFilterNoticeAapraitre()) {
      const _filter: IFilterNoticeAapraitre = filterToQueryNoticeAapraitre({
        ...listfilter,
        ...(sortField && { SortField: sortField }),
        ...(isDescending !== null && { IsDescending: isDescending }),
        ...(limit >= 0 && { Limit: limit }),
        ...(offset >= 0 && limit >= 0 && { Offset: offset })
      });
      setSearchParamsNoticeAparaitre(_filter);
      localStorage.setItem("IFilterNoticesAapraitre",JSON.stringify(_filter));
    }
  }, [listfilter, sortField, isDescending, offset, limit]);

  const { data: NoticesAparaitreResult, isFetching: isFetchingAparaitre, error:errorAparaitre } = useFetchNoticesAparaitreQuery(searchParamsNoticeAparaitre, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || searchParamsNoticeAparaitre === null || searchParamsNoticeAparaitre === undefined ,
  });
  
  useEffect(() => {
    setNumberOfResults(NoticesAparaitreResult?.Quantite ?? null);
    localStorage.setItem(
      "NoticesNavigator",
      JSON.stringify(NoticesAparaitreResult?.Notices?.map(n => ({ Ean: n.Ean, idnotice: n.Id })))
    );
  }, [NoticesAparaitreResult]);
  

  const actions: ILocation[] = [
    {
      PathsName: { Consulter: "/noticesaparaitre/noticedetails/[[Ean]]/[[Id]]" },
      State: { type_access: "" },
      ClassName: "bi-receipt fs-5 mb-2",
    },
    {
          PathsName: (index) => { 
            let statut = ModificationBloque(NoticesAparaitreResult?.Notices[index]?.Source ?? "",NoticesAparaitreResult?.Notices[index].Support?.supportId ?? "","") ? " (impossible)" : "";
            if (statut === "") {
              const nbDemande = (NoticesAparaitreResult?.Notices[index]?.DemandesAuto ?? 0);
              statut = nbDemande > 0 ? ` (${nbDemande} en cours)` : "";
            }
            const lbl = `Modifications physiques et commerciales ${statut}`;
            return { [lbl] : "/noticesaparaitre/noticedetailsmodifauto/[[Ean]]/[[Id]]" }
          },
          State: { type_access: "" },
          //ClassName: "bi-pencil",
          ClassName: (index) => {
            let classname = ModificationBloque(NoticesAparaitreResult?.Notices[index]?.Source ?? "",NoticesAparaitreResult?.Notices[index].Support?.supportId ?? "","") ? "bi-pencil text-reddark fs-5 mb-2" : "";
    
            if (classname === "") {
              classname = (NoticesAparaitreResult?.Notices[index]?.DemandesAuto ?? 0) > 0 ? "bi-pencil text-orange fs-5 mb-2" : "";
            }
             if (classname === "") {
              classname = "bi-pencil fs-5 mb-2"
            }
    
            return classname;
          },
          ActionCallBack: (index) => {
            const ModificationBloqueMessage = ModificationBloque(NoticesAparaitreResult?.Notices[index]?.Source ?? "",NoticesAparaitreResult?.Notices[index].Support?.supportId ?? "","Modifcations automatisés impossible pour cette notice.");
            if (ModificationBloqueMessage !== undefined) {
              toast.error(ModificationBloqueMessage);
              return false;
            } else {
              return true;
            }
          }
        },
    {
      PathsName: { "Modifcations par message": "/noticesaparaitre/noticedetailsmessage/[[Ean]]/[[Id]]" },
      State: { type_access: "" },
      ClassName: (index) => {
        const classname = SourcesModifiable.some(item => item.Libelle === NoticesAparaitreResult?.Notices[index].Source) ? "bi-chat-left-text fs-5 mb-2" : "bi-chat-left-text text-reddark fs-5 mb-2";//bi-ban
        return classname;
      },
      ActionCallBack: (index) => {
        const ModificationBloqueMessage = ModificationBloque(
          NoticesAparaitreResult?.Notices[index]?.Source ?? "",
          NoticesAparaitreResult?.Notices[index].Support?.supportId ?? "",
          "Modifcations par message impossible pour cette notice.");

        if (ModificationBloqueMessage !== undefined) {
          toast.error(ModificationBloqueMessage);
          return false;
        } else {
          return true;
        }
      }
    },
  ];
  const toggleview : IToggleView = {
    ToggleImageFieldName: "ImageCouverture",
    ToggleTextFieldName: "resumeElectre",
  }
  const dataHeaderName: ITitle[] = [
    {
      Id: "",
      Name: <HtmlRenderModalImage />,
      Class: "",
    },
    {
      Id: "disponibiliteEtendue",
      Name: "Dispo",
      Class: "",
    },
    {
      Id: "dateParution",
      Name: "Date Parution",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        a?.dateParution?.localeCompare(b?.dateParution),
    },
    {
      Id: "Auteur",
      Name: "Auteur",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        a?.Auteur?.localeCompare(b?.Auteur),
    },
    {
      Id: "Titre",
      Name: "Titre",
      Class: "",
      sorter: (a: INoticeDTO, b: INoticeDTO) =>
        a?.Titre?.localeCompare(b?.Titre),
    },
    {
      Id: "Ean",
      Name: "Ean",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        a?.Ean?.localeCompare(b?.Ean),
    },
    {
      Id: "Editeur",
      Name: "Editeur",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        a?.Editeur?.localeCompare(b?.Editeur),
    },
    {
      Id: "prix",
      Name: "Prix TTC",
      Class: "",
      sorter: (a: INoticeDTO, b: INoticeDTO) =>
        a?.prix?.localeCompare(b?.prix),
    },
    {
      Id: "distributeur",
      Name: "distributeur",
      Class: "",
      sorter: (a: INotice, b: INotice) =>
        a?.distributeur?.localeCompare(b?.distributeur),
    },

  ];





  const dataItemsStyle = {
    ImageCouverture: "",
    Disponible:<HtmlRenderDisponibiliteEtendu tableau={true}/>,
    DateParution: "",
    Auteur:"",
    Titre: "",
    Ean: "",
    Editeur: "",
    prix: "",
    distributeur :"",
  };

const navigate = useNavigate();


  
  return (
    <>
  <div className="container text-start">
    <div className="row pt-3 pb-5">
      <div className="col col-12">
        <h2 className="titreModule titre-bleu"><i className="bi-book pe-2" />Dates de parution à surveiller : liste des notices</h2>
      </div>
    </div>

    <div className="row justify-content-center d-flex mb-3 mt-2">
      <div className="card" style={{ width: 'fit-content', maxWidth: '100%', padding: '20px' }}>
        <i
          className="bi bi-info-circle"
          style={{
            textAlign: 'end',
            top: '10px',
            left: '10px',
            fontSize: '20px',
          }}
        />
        <p style={{ wordWrap: 'break-word', overflowWrap: 'break-word' }}>
          Les ouvrages de la liste de résultat ont une date de parution dépassée, et leur disponibilité est &quot;<b>à paraître</b>&quot;.<br />
          Pour que ces notices puissent passer à l&apos;état &quot;<b>disponible</b>&quot; sur Electre vous pouvez confirmer leur parution ou nous indiquer les dates de report et les abandons de projet.
        </p>
      </div>
    </div>

    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
    {errorAparaitre && <div>Error</div>}
             
             <CpntFacette
               Libelle="Dates de parution à surveiller"
               Quantite={NoticesAparaitreResult?.Quantite ?? 0}
               SkeletonVisible={isFetchingAparaitre || !NoticesAparaitreResult}
               cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
               cssClassInnerBox={`facette-color-notification ${
                 NoticesAparaitreResult?.Quantite === 0 ? "facette-disabled" : ""
               }`}
               FacetteSelected={false}
               onChange={(event) => navigate("/noticesaparaitre")} 
               InfoBulle={
                 NoticesAparaitreResult?.Quantite === 0 
                   ? "Aucune notice concernée par l'alerte à paraître"
                   : ""
               }
               Disabled = {NoticesAparaitreResult?.Quantite === 0}
             />
   {/* {NoticesAparaitreResult?.Notices && numberOfResults !== null && numberOfResults > 0 && (
    <>
         <button
            className="btn btn-secondary col-4 grandBoutton"
            style={{
              width: "25%",
              alignSelf: 'flex-start', 
              marginLeft: 'auto',
              margin: '5px' 
            }}
            type="submit"
            disabled={(selectedIds?.length || 0) <= 0}
          >
            Modification groupée
        </button>
    </>
   )} */}
</div>
    <div className="row">
      {numberOfResults !== null && NoticesAparaitreResult?.Notices &&
        <div className="col-auto pb-3 pt-3">
          Nb de résultats :<b>&nbsp;{numberOfResults}&nbsp;</b>
        </div>
      }
      {isFetchingAparaitre ? (
        <SpinnerEditeurPro />
      ) : errorAparaitre ? (
        <div>Error</div>
      ) : (
        NoticesAparaitreResult?.Notices && numberOfResults !== null && numberOfResults > 0 &&
        <>
          <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
          <div className="card p-0 mb-2">
            <div className="table-responsive">
              <CpntDataTable
                data={NoticesAparaitreResult && NoticesAparaitreResult.Notices ? [...NoticesAparaitreResult.Notices] : []}
                dataHeader={dataHeaderName}
                dataItemsStyle={dataItemsStyle}
                actions={actions}
                toggleview={toggleview}
                // checkbox={true}
                actualFilterPage="PageNoticesAapraitre"
                updateSorter={setSortField}
                updateDescending={setIsDescending}
                //onSelectionChange={setSelectedIds}
              />
            </div>
          </div>
          <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
        </>
      )}
    </div>
  </div>
</>

  );
};

export default PageNoticesAparaitre;
